module.exports = __webpack_public_path__ + "img/Frueher-1407@2x.11782e54.jpg";